const local: App.I18n.Schema = {
  system: {
    title: 'IoT运营管理平台',
    firstDesc: 'IoT开发，物联运营',
    sedDesc: '更简便 & 更快捷',
    name: '运营管理平台'
  },
  common: {
    action: '操作',
    add: '新增',
    addSuccess: '添加成功',
    backToHome: '返回登录',
    batchDelete: '批量删除',
    cancel: '取消',
    close: '关闭',
    check: '勾选',
    expandColumn: '展开列',
    columnSetting: '列设置',
    resetColumn: '重置列设置',
    config: '配置',
    confirm: '确认',
    confirmDelete: '您确定要删除吗?',
    edit: '编辑',
    index: '序号',
    keywordSearch: '请输入关键词搜索',
    logout: '退出登录',
    logoutConfirm: '确认退出登录吗？',
    lookForward: '敬请期待',
    modify: '修改',
    modifySuccess: '修改成功',
    noData: '无数据',
    operate: '操作',
    pleaseCheckValue: '请检查输入的值是否合法',
    refresh: '刷新',
    reset: '重置',
    search: '搜索',
    switch: '切换',
    tip: '提示',
    trigger: '触发',
    update: '更新',
    updateSuccess: '更新成功',
    userCenter: '个人中心',
    companyMsg: '公司信息',
    yesOrNo: {
      yes: '是',
      no: '否'
    },
    ensure: '确定',
    back: '返回',
    status: {
      enable: '启用',
      disable: '禁用'
    },
    listNone: '暂无数据',
    delTitle: '确认删除',
    delStr: '您确认要删除此{typeName}吗？此操作无法撤销。',
    delete: '删除',
    deleteSuccess: '删除成功',
    save: '保存',
    submit: '提交',
    nextStep: '下一步',
    online: '在线',
    offline: '离线',
    upload: '上传文件',
    settingSuccess: '设置成功',
    haddleSuccess: '操作成功',
    uploadSuccess: '上传成功',
    uploadError: '上传失败',
    haddleError: '操作失败',
    langManage: '语种管理',
    current: "当前",
    createStartTime: '创建开始时间',
    createEndTime: '创建结束时间'
  },
  base: {
    table: {
      updateTime: '更新时间'
    },
    form: {
      string2To50: '请输入2~50位的有效字符串，禁止输入<>',
      string2To200: '请输入2~200位的有效字符串，禁止输入<>',
      select: '请选择'
    }
  },
  request: {
    logout: '请求失败后登出用户',
    logoutMsg: '用户状态失效，请重新登录',
    logoutWithModal: '请求失败后弹出模态框再登出用户',
    logoutWithModalMsg: '用户状态失效，请重新登录',
    refreshToken: '请求的token已过期，刷新token',
    tokenExpired: 'token已过期'
  },
  route: {
    user: '',
    login: '视声运营管理平台',
    403: '无权限',
    404: '页面不存在',
    500: '服务器错误',
    home: '首页',
    exception: '异常页',
    exception_403: '403',
    exception_404: '404',
    exception_500: '500',
    system: '系统管理',
    system_account: '账号管理',
    'system_application-template': '应用模版管理',
    system_category: '标准品类管理',
    system_menu: '菜单管理',
    system_role: '角色与权限',
    application: '应用开发与运营',
    application_develop: '应用开发',
    client: '客户管理与运营',
    client_management: '客户管理',
    client_platform: '客户平台配置',
    data: '数据统计与分析',
    'data_all-screen': '数据大屏',
    'data_app-chart': '应用看板',
    'data_product-chart': '产品看板',
    product: '产品研发与运营',
    product_debug: '设备调试',
    product_develop: '产品开发',
    product_device: '设备管理',
    product_firmware: '固件OTA',
    'product_firmware-add': '创建OTA任务',
    'product_firmware-list': 'OTA任务',
    'product_firmware-task-detail': '设备升级记录',
    product_log: '设备日志',
    'system_account-add': '创建系统账号',
    'system_account-permission': '权限设置',
    'system_category-detail': '标准品类详情',
    'system_category-add': '创建标准品类',
    'system_menu-lang': '菜单多语言',
    'system_firmwaretype': '产品固件类型配置管理',
    'system_firmwaretype-lang': '固件类型多语言配置',
    user_center: '用户中心',
    'user_reset-password': '重置密码',
    'user_reset-email': '重置邮箱',
    user_company: '公司信息',

    'client_management-add': '创建客户',
    'client_management-edit': '编辑客户',

    'product_develop-add': '创建产品',
    'product_develop-detail': '产品详情',
    'product_device-detail': '设备详情',
    'product_develop-lang': '产品多语言设置',

    'product_debug-add': '创建Mock设备',
    'product_debug-detail': 'Mock设备详情',

    // 路由页面标题
    '1': '首页',
    '2_7': '系统账号',
    '2_8': '角色管理',
    '2_9': '标准品类列表',
    '2_10': '应用模板列表',
    '2_12': '菜单管理',
    '3_13': '客户管理',

    '4_15': '产品开发',
    '4_16': '设备管理',
    '4_17': '固件OTA',
    '4_18': '产品Mock列表',
    '4_19': '设备日志',
    '5_20': '应用开发',
    '6_23': '应用看板',
    // '4_15_339': '产品详情',
    // '4_16_344': '设备详情',
    // '2_9_325': '标准品详情',
    // '3_13_336': '编辑客户'
  },
  page: {
    login: {
      common: {
        loginOrRegister: '登录',
        userNamePlaceholder: '请输入用户账号',
        phonePlaceholder: '请输入手机号',
        codePlaceholder: '请输入验证码',
        passwordPlaceholder: '设置新密码',

        confirmPasswordPlaceholder: '请再次输入密码',
        codeLogin: '验证码登录',
        confirm: '确定',
        back: '返回',
        validateSuccess: '验证成功',
        loginSuccess: '登录成功',
        welcomeBack: '欢迎回来，{userName} ！',
        newPassword: '新密码',
        passStep1: '密码长度6-50个字符',
        passStep2: '密码不能包含空格',
        passStep3: '密码必须包含字母、数字',
        passStep4: '密码不能包含中文、中文符号'
      },
      pwdLogin: {
        title: '欢迎登录',
        rememberMe: '记住我',
        forgetPassword: '忘记密码'
      },
      resetPwd: {
        title: '重置密码',
        getCode: '获取验证码',
        reGetCode: '{time}秒后重新获取',
        sendCodeSuccess: '验证码发送成功',
        checkCodeSuccess: '验证码验证成功',
        checkCodeFail: '验证码错误或过期，请确认验证码是否正确或重新获取',
        checkCodeNotFound: '请先获取验证码以进行验证',
        resetSuccess: '重置密码成功'
      }
    },

    home: {
      welcome: '欢迎使用',
      prod: '产品开发',
      app: '应用开发',
      data: '数据统计分析',
      prodDesc: '产品设备统一管理，OTA升级',
      appDesc: '快速进行应用配置及管理',
      dataDesc: '获取分析数据',
      more: '了解详情',
      plan: '方案推荐',
      hotPlan: '热门方案',
      newPlan: '最新方案',
      newProd: '新产品快讯',
      message: '消息中心',
      help: '帮助中心',
      showMore: '查看更多'
    },
    category: {
      title: '标准品类列表',
      detail: '表格页用于展示多条结构类似的数据， 可对数据进行排序、筛选、对比或其他自定义操作。',
      icon: '标品图片',
      name: '标准品类',
      namePlaceholder: '请输入标准品类',
      belongClass: '标准类目',
      belongClassPlace: '请选择标准类目',
      vision: '当前版本',
      statement: '状态',
      statementPlace: '请选择状态',
      releaseStatus: '发布状态',
      releaseStatusPlace: '请选择发布状态',
      createTs: '创建时间',
      addCategory: '创建标准品类',
      reaStatusList: {
        enable: '已发布',
        disable: '未发布'
      },
      stateSuccess: '标准品类【{categoryName}】状态切换为：{state}',
      detailBtn: '详情',
      model: '配置功能模型',
      addModelRes: '标准品类创建成功',
      configTip: '请配置功能分组及功能点',
      configNone: '暂未配置功能分组及功能点',
      addGroup: '添加功能分组',
      addGroupSuccess: '功能分组【{groupName}】添加成功',
      selectFun: '添加标准功能',
      addFun: '新增标准功能',
      functionName: '功能名称',
      functionId: '功能ID',
      functionType: '功能类型',
      signCode: '功能标识',
      signCodeSum: '功能属性汇总',
      swithcFun: '关联其他功能ID',
      funTip: '功能备注',
      setDefault: '设置默认功能',
      modelFile: '查看模型文件',
      closeAll: '收起全部',
      openAll: '展开全部',
      pickFun: '选择标准功能',
      pickedFun: '已选功能',
      clearFun: '清除全部可选功能',
      searchPlace: '可输入标品名称、功能点名称、功能点标识查询',
      groupName: '功能分组',
      dataType: '数据类型',
      readType: '读写类型',
      desc: '描述',
      attributes: '属性',
      event: '事件',
      server: '服务',
      status: '选择状态',
      funNone: '暂无功能点',
      switchFunPlaceHolder: '请选择关联功能点（可多选）',
      requiredList: {
        enable: '默认',
        disable: '取消默认'
      },
      requiredSuccess: '功能【{functionName}】已设置为：{required}',
      readWrite: '读写',
      onlyRead: '只读',
      onlyWrite: '只写',
      maxTip: '最大值必须大于最小值，请重新输入',
      minTip: '最小值必须小于最大值，请重新输入',
      bite: '字节',
      enum: '枚举值',
      addEnum: '添加枚举值',
      arrayType: '元素类型',
      jsonObj: 'Json对象',
      addParam: '增加参数',
      booleanVal: '布尔值',
      jsonTitle: 'Json对象参数',
      addFunSuccess: '标准功能【{functionName}】创建成功',
      selectFunSuccess: '标准功能添加成功',
      inputLabel: '输入参数',
      outputLabel: '输出参数',
      info: '消息',
      call: '通知',
      debug: '告警',
      eventType: '事件类型',
      editFun: '编辑标准功能',
      updFunSuccess: '标准功能【{functionName}】更新成功',
      range: '数值范围',
      function: '标准功能',
      editGroup: '编辑功能分组',
      editGroupSuccess: '功能分组【{groupName}】更新成功',
      fold: '收起',
      unFold: '展开',
      listing: '上架',
      delist: '下架',
      editBaseSuccess: '标准品类更新成功',
      listCheck: {
        title: '确认上架',
        detail: '您确认要上架该标准品类吗？此操作无法撤销。',
        confirm: '上架',
        success: '上架成功'
      },
      unlistCheck: {
        title: '确认下架',
        detail: '您确认要下架该标准品类吗？此操作无法撤销。',
        confirm: '下架',
        success: '下架成功'
      },
      exportFile: '导出模型文件',
      jsonIntro:
        '物模型是对设备在云端的功能描述，包括设备的属性、服务和事件。物联网平台通过定义一种物的描述语言来描述物模型，称之为TSL(即 Thing Specification Language)，采用JSON格式，您可以根据TSL组装上报设备的数据。您可以导出完整物模型，用于云端应用开发；您也可以只导出精简物模型，配合设备端SDK实现设备开发。',
      modelFileTitle: '模型文件',
      item: '标准品类',
      relateFunSuccess: '关联功能更新成功',
      relateTip: '当前功能点存在依赖功能点，已为您自动勾选',
      relateCancelTip: '当前功能点存在依赖功能点，已为您同步取消勾选',
      sameSignCodeTip: '当前功能点与已选功能存在重复标识符，无法勾选',
      allSameTip: '所有已选功能均包含在功能列表中，请重新选择您需要的功能',
      filterSameTip: '部分已选功能的标识符 ({codeStr}) 存在重复，系统已自动为您进行过滤',
      mock: '一键Mock',
      multiLang: '多语言设置'
    },
    account: {
      title: '系统账号',
      detail: '表格页用于展示多条结构类似的数据， 可对数据进行排序、筛选、对比或其他自定义操作。',
      nickname: '用户昵称',
      name: '用户账号',
      accountValidity: '账号有效期',
      createAccount: '创建账号',
      createAccountLog: '创建系统账号',
      createAccountSuccess: '创建系统账号成功',
      createAccountPullTitlle: "是否同步账号",
      createAccountPull: "{typeEmail}已被账号{typeName}使用，您确认要同步该账号到当前平台下吗？",
      createAccountMsg: '具体账号信息已发送到对应邮箱',
      accountAuthorization: '去账号授权',
      isResetPwd: '是否重置当前账号密码？',
      permissionSet: '权限设置',
      deleteAccountTip: '是否重置注销当前账号？注销后，账号信息将清除',
      deleteAccount: '注销',
      accountPlaceholder: '用户昵称/用户账号/邮箱',
      selectRoleType: '选择角色类型',
      customRole: '自定义角色',
      menuPermissions: '菜单权限',
      dataPermissions: '数据权限',
      selectProduct: '选择产品',
      selectProductNum: '已选择{products}款产品',
      allProduct: '全部产品',
      allProductSupport: '（包括之后创建的所有产品）',
      selectApply: '选择应用',
      selectApplyNum: '已选择{applies}款应用',
      allApply: '全部应用',
      allApplySupport: '（包括之后创建的所有应用）',
      noSetRole: '您当前未设置账号权限，是否保存当前选中的权限设置？',
      permissSuccess: '权限设置成功',
      timeSwitch: '{start} 至 {end}',
      resetPwd: {
        title: '确认重置',
        detail: '您确认要重置该账号{typeName}的密码吗？此操作无法撤销。',
        confirm: '重置密码',
        success: '重置密码成功，账号密码信息已发送到对应邮箱。'
      },
      cancelAcc: {
        title: '确认注销',
        detail: '您确认要注销该账号{typeName}吗？注销后，账号信息将清除，此操作无法撤销。',
        confirm: '注销',
        success: '注销成功'
      },
      dateTip: '当创建账号时，有效时间可以默认不填写，不填即代表账号永久有效。',
      foreverDate: '永久有效'
    },
    role: {
      title: '角色管理',
      detail: '表格页用于展示多条结构类似的数据， 可对数据进行排序、筛选、对比或其他自定义操作。',
      name: '角色名称',
      deleteTip: '是否删除当前角色？',
      createRole: '创建角色',
      editRole: '编辑角色',
      permissions: '角色权限',
      roleName: {
        label: '角色名称',
        placeHolder: '2~50位的有效字符串',
        required: '角色名称不得为空，请确认输入',
        invalid: '角色名称格式不正确'
      },
      createRoleTip: '角色已达到30个了',
      item: '角色'
    },
    firmwareType: {
      add: '新增固件类型',
      addVersion: '新增固件版本',
      no: 'No.',
      maxLength: '固件类型新增已达上限！最多配置100个',
      lang: "固件类型多语言配置",
      remarkEn: '版本说明（英文）',
      lowVersion: '最低版本支持',
      dependency: '依赖项管理（可选）',
      chooseTip: '请您优先选定当前新增/编辑固件版本所对应的固件类型，再进行依赖项配置',
      saveSuccess: '固件类型配置更新成功！',
      minVersionRequired: '最低版本支持需填写完整，请确认输入',
      firmwareTypeIdForm: {
        label: '固件类型编号',
        required: '固件类型编号不得为空，请确认输入',
        placeHolder: '请输入固件类型编号'
      },
      firmwareTypeNameForm: {
        label: '固件类型名称',
        required: '固件类型名称不得为空，请确认输入',
        placeHolder: '请输入固件类型名称'
      },
      multiType: '固件类型-版本',
      multiTargetType: '固件类型-原版本号-目标版本号',
      clickTitle: '点击查看',
      sameNoTip: '固件类型编号不能重复，请确认输入',
      sameNameTip: '固件类型名称不能重复，请确认输入',
      noneVersion: '未上报',
      sameTypeTip: '依赖项配置中固件类型不能重复，请确认输入',
      minVerTip: '最低版本支持不可高于或等于当前固件版本号',
      sameOtaVersion: '固件类型/版本不能重复，请确认输入',
      dependencyLabel: '依赖项管理'
    },
    application: {
      title: '应用模板列表',
      detail: '表格页用于展示多条结构类似的数据， 可对数据进行排序、筛选、对比或其他自定义操作。'
    },
    multilingual: {
      title: '多语言列表',
      detail: '表格页用于展示多条结构类似的数据， 可对数据进行排序、筛选、对比或其他自定义操作。'
    },
    menu: {
      title: '菜单管理',
      detail: '表格页用于展示多条结构类似的数据， 可对数据进行排序、筛选、对比或其他自定义操作。',
      addOneMenu: '添加一级菜单',
      deleteTip: '是否删除当前菜单项？ 将影响页面操作，请谨慎操作！',
      setPerms: '设置权限标识',
      perms: {
        label: '权限标识',
        required: '权限标识不得为空，请确认输入',
        placeHolder: '请输入权限标识'
      },
      oneMenu: '一级菜单',
      twoMenu: '二级菜单',
      threeMenu: '三级菜单',
      menuName: '菜单名称',
      menuPlaceholder: '请输入菜单名称',
      menuNameForm: {
        label: '菜单名称',
        required: '菜单名称不得为空，请确认输入',
        invalid: '菜单名称格式不正确',
        placeHolder: '请输入菜单名称'
      },
      menuLang: '菜单多语言设置'
    },
    menuLang: {
      belongMenu: '所属菜单',
      edit: '文案修改',
      code: '词条code'
    },
    client: {
      title: '客户管理',
      detail: '表格页用于展示多条结构类似的数据， 可对数据进行排序、筛选、对比或其他自定义操作。',
      dateCenter: '数据中心列表获取失败',
      base: '客户基本信息',
      admin: '客户超级系统管理员信息',
      updateAdmin: '管理员信息更新成功',
      namePlaceholder: '租户UUID/客户全称/客户统一社会信用代码/客户域名',
      create: '创建客户',
      uuid: '客户UUID',
      id: '客户ID',
      status: '启用状态',
      stateSuccess: '客户【{clientName}】状态切换为：{state}',
      deleteTip: '是否删除当前客户',
      startStauts: '客户启用后，客户下的所有应用、\n设备都恢复使用',
      disableUserValidate: '禁用客户验证',
      disableUserTip: '客户禁用后，客户下的所有应用、设备都无法使用，请谨慎操作！',
      disableUser: '禁用客户',
      item: '客户',
      oem: 'OEM配置',
      reset: '恢复默认'
    },
    devices: {
      selectProduct: '产品',
      selectCategory: '品类',
      selectStatus: '状态',
      selectDataCenter: '数据中心',
      namePlaceholder: '设备ID/MAC地址',
      inputNamePlaceholder: '请输入设备ID/MAC地址',
      deviceProduct: '设备关联产品名称：',
      deviceId: '设备ID',
      deviceName: '设备名称',
      productName: '所属产品',
      productId: '产品ID',
      mac: 'MAC地址',
      online: '在线状态',
      lastOnlineTime: '最近一次上线时间',
      lastOfflineTime: '最近一次下线时间',
      log: '日志',
      record: '记录',
      functionType: '功能类型',
      functionId: '功能ID',
      messageId: 'messageId',
      flow: '数据来源',
      dataDetail: '数据详情',
      messageTimestamp: '触发时间',
      deviceMsg: '设备信息',
      deviceLog: '设备上下线记录',
      beProduct: '所属产品',
      deviceMac: '设备MAC',
      deviceCategory: '所属品类',
      deviceVersion: '设备固件版本',
      systemVersion: '设备系统版本',
      deviceMCU: '设备MCU版本',
      deviceNetwork: '设备网络信息',
      deviceArea: '设备所属地区',
      inputSearchTip: '请先输入设备ID/MAC地址',
      tipEnterTip: '按回车搜索设备日志列表'
    },
    deviceLog: {
      title: '设备日志',
      detail: '表格页用于展示多条结构类似的数据， 可对数据进行排序、筛选、对比或其他自定义操作。',
      timeTip: '当前支持查询设备7天的日志数据，想要查询更多数据，请联系商务开启服务',
      contact: '联系邮箱：',
      deviceFlow: '设备端',
      iCloudFlow: '云端',
      customCode: '自定义标识符',
      systemCode: '系统标识符'
    },
    product: {
      title: '产品列表',
      detail: '表格页用于展示多条结构类似的数据， 可对数据进行排序、筛选、对比或其他自定义操作。',
      productName: '产品名称',
      productId: '产品ID',
      pic: '产品图片',
      productType: '标准类目',
      productClass: '产品品类',
      protocol: '通讯方式',
      status: '开发状态',
      addProduct: '创建产品',
      searchName: '产品名称/产品Id',
      productTypePlace: '请选择标准类目',
      productClassPlace: '请选择产品品类',
      item: '产品',
      wifi: 'WIFI',
      knx: 'KNX',
      zigbee: 'Zigbee',
      ethernet: '以太网',
      honey: '蜂窝',
      blue: '蓝牙',
      stepSelect: '选择标准品类',
      stepSelectTip: '标准品类为模板基础',
      stepSet: '产品信息自定义设置',
      stepSetTip: '在标准品类为模板基础上，设置产品信息',
      searchCate: '标准品类名称查询',
      allClass: '全部标准类目',
      categoryNone: '该分类下暂无标准品类',
      next: '下一步',
      choose: '下一步（已选择标准品类：{categoryName}）',
      monomer: '单体',
      gateway: '网关',
      gatewaySub: '网关子设备',
      backChoose: '已选择标准品类：{categoryName}',
      back: '重新选择',
      addProdRes: '产品创建成功',
      info: '产品信息',
      model: '产品功能模型',
      config: '产品配置',
      firmVision: '固件版本',
      cateName: '所属标准品类',
      editBaseSuccess: '产品信息更新成功',
      updFunSuccess: '产品功能【{functionName}】更新成功',
      addFunSuccess: '产品功能【{functionName}】创建成功',
      function: '产品功能',
      editFun: '编辑产品功能',
      addFun: '新增自定义功能',
      loRaWAN: 'LoRaWAN',
      listCheck: {
        title: '确认上架',
        detail: '您确认要上架该产品吗？此操作无法撤销。',
        confirm: '上架',
        success: '上架成功'
      },
      unlistCheck: {
        title: '确认下架',
        detail: '您确认要下架该产品吗？此操作无法撤销。',
        confirm: '下架',
        success: '下架成功'
      },
      scene: '应用场景',
      toConfig: '配置',
      configRes: '应用场景配置成功',
      configTitle: '配置应用场景',
      appId: '应用ID',
      appName: '应用名称',
      appNone: '暂未配置应用场景',
      firmwareTypePlace: '请选择固件类型',
      firmwareUpdPlace: '请选择固件升级方式',
      firmwareStatusPlace: '请选择固件版本状态',
      versionNumberPlace: '版本号',
      other: '其他',
      firmwareOption: {
        mcu: 'MCU固件',
        system: '系统固件',
        software: '软件固件',
        other: '其他'
      },
      firmwareUpd: {
        notice: '提醒升级',
        force: '强制升级',
        check: '检测升级'
      },
      firmwareNone: '暂无固件版本',
      firmwareColumns: {
        name: '固件版本名称',
        vision: '固件版本号',
        file: '固件文件',
        type: '固件类型',
        timeout: '固件升级超时时间',
        upd: '固件升级方式',
        status: '版本状态',
        tip: '版本说明',
        disabled: '停用下架',
        listing: '上架',
        add: '新增固件版本',
        edit: '编辑固件版本',
        check: '查看固件版本',
        min: '分钟',
        item: '固件'
      },
      firmwareList: '上架固件版本',
      disableTitle: '下架固件版本',
      firmwareAlert: '上架主要用于控制当前固件版本是否可用于固件升级',
      firmwareConfirm: '固件信息确认',
      firmwareRange: '设置允许使用范围',
      noRange: '不限范围',
      limitRange: '限定范围',
      limitTitle: '已授权范围',
      limitNoneTip: '已授权范围不得为空，请选择设备',
      editLimit: '修改授权范围',
      addLimit: '添加',
      limitAlert: '仅支持授权范围内的设备可使用该固件版本，用于固件升级',
      configNone: '暂无应用场景数据可配置',
      configListTitle: '已配置应用场景列表',
      devSameTip: '选择的设备存在重复，请重新输入',
      addFirmwareSuccess: '固件版本【{versionName}】创建成功',
      editFirmwareSuccess: '固件版本【{versionName}】更新成功',
      enableStatusSuccess: '固件【{versionName}】版本状态更新为：已上架',
      disableStatusSuccess: '固件【{versionName}】版本状态更新为：已下架',
      firmwareStatus: {
        listing: '上架',
        delist: '未上架'
      },
      selectFunSuccess: '产品功能添加成功',
      file: '文件上传',
      fileMd5: '文件解析中...',
      info1: '1、上传大文件时，请耐心等待',
      info2: '2、正在上传文件时，关闭弹窗将会清除当前固件文件，但会保存上传进度',
      info3: '3、二次上传固件，将会覆盖旧的固件文件',
      chooseFile: '选择文件',
      sceneTitle: '自动化场景设置',
      sceneCondition: '场景触发条件设置',
      sceneMission: '场景执行任务设置',
      conditionTip:
        '场景触发条件设置以后，该功能点即可出现在 App > 智能场景 > 新建场景 > 添加条件处，作为场景的触发条件来设置。',
      missionTip:
        '场景执行条件设置以后，该功能点即可出现在 App > 智能场景 > 新建场景 > 添加任务处，作为场景的执行条件来设置。',
      closeTitle: '关闭提示',
      closeStr: '您确定要关闭弹窗并中断文件上传吗？',
      fileNoneFinish: '文件未完成上传，请耐心等待',
      subDevice: '查看子设备',
      gatewayDevice: '查看网关子设备',
      sceneTip:
        '自定义设置功能点是否支持智能场景触发条件、执行任务，勾选支持以后用户即可在App智能场景进行对应功能的设置。',
      sceneRes: '自动化场景设置成功',
      copy: '一键复制',
      copyTitle: '一键复制产品',
      chooseClient: {
        label: '选择客户',
        required: '选择客户不得为空，请确认输入',
        placeHolder: '请选择客户'
      },
      copyAlert: '确定复制“{product}”后，会自动创建一个新产品。新产品默认为未发布状态',
      copyAble: '支持复制',
      copyDisable: '不支持复制',
      copySuccess: '复制成功！',
      copyProdName: '复制-'
    },
    company: {
      name: {
        label: '全称',
        required: '全称不得为空，请确认输入',
        invalid: '请输入2~50位有效字符，禁止输入<>',
        placeHolder: '2~50位的有效字符串'
      },
      abbrName: {
        label: '简称',
        required: '简称不得为空，请确认输入',
        invalid: '请输入2~50位有效字符，禁止输入<>',
        placeHolder: '2~50位的有效字符串'
      },
      country: {
        label: '所在地区',
        required: '所在地区不得为空，请确认输入',
        invalid: '所在地区格式不正确',
        placeHolder: '2~200位的有效字符串'
      },
      domainName: {
        label: '域名',
        required: '域名不得为空，请确认输入',
        invalid: '请输入格式正确域名，允许英文、数字、符号 . - 组合',
        placeHolder: '域名格式'
      },
      recordNumber: {
        label: '备案号',
        required: '备案号不得为空，请确认输入',
        invalid: '备案号格式不正确',
        placeHolder: '2~50位的有效字符串'
      },
      logo: {
        label: 'logo',
        invalid: '请提供图标：尺寸为180x48像素，PNG格式，文件大小不超过3M。',
        placeHolder: '点击上传图片',
        required: '请上传图片'
      },
      systemName: {
        label: '系统名称',
        required: '系统名称不得为空，请确认输入',
        invalid: '系统名称格式不正确',
        placeHolder: '2~200位的有效字符串'
      }
    },
    userCenter: {
      base: '基本信息',
      accountName: '用户账号',
      sex: '用户性别',
      login: '登录信息',
      password: '登录密码',
      passwordTip: '建议您定期更改密码，以保证账号安全',
      changePassword: '修改密码',
      bindEmail: '绑定邮箱',
      bindedEmail: '您已绑定邮箱：{email}',
      editEmail: '修改邮箱',
      resetBind: '重新绑定',
      sendCode: '发送验证码',
      finish: '完成',
      male: '男',
      female: '女',
      noSelectSex: '暂未选择性别',
      updatePswSuccess: '密码重置成功',
      reconfirm: '重新登录',
      resetEamilTip: '恭喜您，提交成功\n新邮箱账号已绑定成功',
      noSelectIcon: '请完善头像信息',
      logoPic: '请提供用户头像，JPG、PNG、JPEG格式，文件大小不超过3M。',
      noConfigSever: '暂无配置数据中心'
    },
    firmware: {
      createOTA: '创建产品OTA',
      view: '查看',
      otaTask: 'OTA任务',
      viewAllOTA: '查看全部OTA任务',
      allClose: '全部关闭',
      taskName: {
        label: '任务名称',
        placeHolder: '2~50位的有效字符串',
        required: '任务名称不得为空，请确认输入',
        invalid: ''
      },
      taskRankAbbr: '优先级',
      taskRank: {
        label: '任务优先级',
        placeHolder: '请选择任务优先级',
        required: '任务优先级不得为空，请确认输入',
        invalid: ''
      },
      taskMsg: {
        label: '升级文案',
        placeHolder: '2~200位的有效字符串',
        required: '升级文案不得为空，请确认输入',
        invalid: ''
      },
      taskType: {
        label: '升级策略',
        placeHolder: '请选择升级策略',
        required: '升级策略不得为空，请确认输入',
        invalid: ''
      },
      taskStartTime: '开始升级时间',
      taskTime: '升级时间',
      executeNow: '是否立即执行',
      firmwareType: {
        label: '固件类型',
        placeHolder: '请选择固件类型',
        required: '固件类型不得为空，请确认输入',
        invalid: ''
      },
      deviceNums: '设备数量',
      rate: '完成率',
      rate1: '完成度',
      selectFirmwareVersion: {
        label: '固件版本',
        placeHolder: '请选择固件版本',
        required: '固件版本不得为空，请确认输入',
        invalid: ''
      },
      selectDevices: '选择设备',
      upgradePolicy: '配置升级策略',
      commonProduct: '常用产品',
      productIDPlaceholder: '请输入产品ID，搜索查看产品信息',
      productDetail: '产品详情',
      productOTATask: '的全部OTA任务',
      updatingNums: '正在升级：{number}个',
      selectUpdatingDevices: '选择升级设备',
      selectXDevices: '（已选择{number}台设备）',
      totalSelectDevices: '共{number}台设备',
      pollTask: '轮询任务',
      onceTask: '单次任务',
      startTime: '开始时间',
      endTime: '结束时间',
      noProduct: '暂无产品信息',
      changeProductTip: '是否切换产品?\n确定后将会重置配置信息',
      inputProduct: '请输入产品ID',
      resetTask: '确定后将会重置配置信息',
      taskSearchInput: '任务ID/任务名称/目标版本号',
      taskStauts: '任务状态',
      firmwareOtaStatus: {
        0: '未开始',
        1: '等待下次执行',
        2: '正在执行',
        3: '暂停',
        4: '已结束',
        5: '已取消'
      },
      otaResultStatus: {
        0: '未开始',
        1: '等待中',
        2: '升级中',
        3: '升级成功',
        4: '升级失败'
      },
      taskId: '任务ID',
      srcVersionNumber: '原版本号',
      targetVersionNumber: '目标版本号',
      updatedResult: '升级结果',
      schedule: '进度状态',
      haddleName: '操作者',
      retryUpdate: '重新批量升级',
      updateAtOnce: '立即升级',
      noSchedStatus: '暂无进度状态',
      overTime: '超时失败',
      overLevel: '优先级更高执行导致当前任务失败',
      sedFail1: '升级文件下载失败',
      sedFail2: '升级文件校验失败',
      sedFail3: '升级文件安装失败',
      showRate: '查看进度状态',
      secondStatus: {
        title1: '收到',
        title2: '下载',
        title3: '校验',
        title4: '安装',
        title5: '重启',
        content1: '设备收到OTA请求',
        content2: '下载进度：{finishNum}%',
        content3: '正在校验升级文件',
        content4: '正在安装升级文件',
        content5: '设备正在重启',
        taskSchedStatus: '任务进度状态'
      },
      detail: '升级记录',
      pause: '暂停',
      play: '开始',
      restart: '重新升级',
      cancel: '取消升级',
      playTip: '任务【{taskName}】开始升级！',
      pauseTip: '任务【{taskName}】暂停升级！',
      restartTip: '任务【{taskName}】重新开始升级！',
      cancelTip: '任务【{taskName}】取消升级！'
    },
    mock: {
      title: '产品Mock列表',
      detail: '表格页用于展示多条结构类似的数据， 可对数据进行排序、筛选、对比或其他自定义操作。',
      searchPlace: '设备Mock名称/MockID/产品ID',
      addCode: '生成二维码',
      addMock: '创建Mock设备',
      addMockSuccess: 'Mock设备创建成功！',
      deviceName: 'Mock名称',
      deviceNamePlaceHolder: '请输入Mock名称',
      deviceId: 'MockID',
      belongClass: '所属产品',
      item: 'Mock设备',
      searchResult: '搜索产品信息为空，请确认输入',
      searchResultErr: '请选择单体或者网关类型产品',
      clearProdId: {
        detail: '您已挂载子设备，更改产品将清空挂载的数据，是否继续操作？',
        confirm: '继续'
      },
      childDev: '挂载子设备',
      selectChildDev: '添加子设备',
      searchChildDev: '请选择子设备进行控制',
      popTip1: '1、只能挂载单体或网关子设备',
      popTip2: '2、挂载上限10台，若实际超出10台，可另建新的设备mock进行调试',
      devChildColumn: {
        id: '子设备ID',
        child: '子设备名称',
        add: '添加数量'
      },
      selectLimit: '选择的产品数量已超过上限！',
      searchFlagTip: '请先搜索当前输入的产品ID是否存在',
      subDev: '挂载子设备',
      control: '控制面板',
      deviceType: {
        all: '全部',
        config: '属性',
        event: '事件',
        server: '服务',
        systemEvent: '系统事件',
        systemServer: '系统服务'
      },
      reset: '一键初始化',
      allSend: '一键发送',
      controlColumn: {
        id: '功能ID',
        name: '功能名称-标识符-功能ID',
        value: '参数值',
        send: '发送',
        init: '初始化',
        setDefVal: '设置预设值'
      },
      realTimeLog: '实时日志',
      keywordPlace: '请输入关键词回车进行搜索',
      clearLog: '清空日志',
      realLogColumn: {
        dataFlow: '数据流向',
        message: '消息类型',
        date: '日期时间',
        info: '内容',
        call: '请求',
        back: '响应'
      },
      devLogin: '设备登录',
      devCerti: '设备身份信息',
      devLogUpdate: '设备实时日志上报',
      tou: '透传',
      token: 'token刷新',
      syncDev: '设备信息同步',
      mqConnectSuc: 'MQTT连接成功！',
      mqConnectFail: 'MQTT连接失败！',
      subscribeFail: 'MQTT订阅主题失败！',
      subscribeSuc: 'MQTT主题订阅成功！',
      loginTitle: '设备登录失败',
      loginStr: '设备登录响应内容：',
      reLogin: '重新登录',
      loginSuc: '设备登录成功',
      editDevName: '修改Mock设备名称',
      copyTip: '复制成功！',
      copyDisabled: '您的浏览器不支持复制',
      setDef: '设置预设值',
      condition: '当{funName}是',
      todoTip: '联动设置：',
      valuePlace: '请输入参数值',
      addPreset: '新增预设值',
      presetFunPlace: '请选择预设功能',
      addPresetMax: '最多联动设置20个功能点',
      addPresetSuccess: '预设值设置成功！',
      static: '静态码'
    },
    data: {
      title: '数据看板',
      systemTitle: '系统数据',
      deviceRankingList: '设备数量最多产品TOP10',
      useProductRankingList: '用户最常用产品TOP10',
      useFunctionRankingList: '用户最常用产品功能TOP10',
      appNums: '应用数',
      appUnit: '个',
      productNums: '产品数',
      productUnit: '款',
      devicesNums: '设备数',
      devicesUnit: '台',
      logNums: '设备日消息',
      logUnit: '条',
      newsNums: '设备累计消息',
      newsUnit: '条',
      realTimeNums: '设备实时在线数',
      useTime: '使用次数',
      areaEurope: '欧洲',
      areaTheMiddleEast: '中东',
      chinaDevicesDistribution: '中国设备分布',
      europeDevicesDistribution: '欧洲设备分布',
      middleEastDevicesDistribution: '中东设备分布',
      statisticsDate: '数据截止统计时间：',
      serveChina: '中国数据中心',
      serveEurope: '欧洲数据中心',
      myriad: '万',
      million: '百万',
      allDevices: '设备总数',
      productDevices: '产品设备数量：',
      productUses: '产品使用次数：',
      startCarousel: '开始轮播',
      stopCarousel: '停止轮播',
      deviceNums: '设备总数',

      // 中国
      beijing: '北京',
      tianjin: '天津',
      hebei: '河北',
      shanxi: '山西',
      neimenggu: '内蒙古',
      liaoning: '辽宁',
      jilin: '吉林',
      heilongjiang: '黑龙江',
      shanghai: '上海',
      jiangsu: '江苏',
      zhejiang: '浙江',
      anhui: '安徽',
      fujian: '福建',
      jiangxi: '江西',
      shandong: '山东',
      henan: '河南',
      hubei: '湖北',
      hunan: '湖南',
      guangdong: '广东',
      guangxi: '广西',
      hainan: '海南',
      chongqing: '重庆',
      sichuan: '四川',
      guizhou: '贵州',
      yunnan: '云南',
      xizang: '西藏',
      shanxi1: '陕西',
      gansu: '甘肃',
      ningxia: '宁夏',
      xinjiang: '新疆',
      qinghai: '青海',
      taiwan: '台湾',
      xianggang: '香港',
      aomen: '澳门',

      // 欧洲
      england: '英国',
      ukraine: '乌克兰',
      switzerland: '瑞士',
      sweden: '瑞典',
      spain: '西班牙',
      slovakia: '斯洛伐克',
      slovenia: '斯洛文尼亚',
      serbia: '塞尔维亚',
      sanmarino: '圣马力诺',
      romania: '罗马尼亚',
      portugal: '葡萄牙',
      poland: '波兰',
      norway: '挪威',
      netherlands: '荷兰',
      moldova: '摩尔多瓦',
      malta: '马耳他',
      macedonia: '马其顿',
      luxembourg: '卢森堡',
      latvia: '立陶宛',
      liechtenstein: '列支敦士登',
      lithuania: '拉脱维亚',
      italy: '意大利',
      ireland: '爱尔兰',
      iceland: '冰岛',
      hungary: '匈牙利',
      greece: '希腊',
      germany: '德国',
      france: '法国',
      finland: '芬兰',
      estonia: '爱沙尼亚',
      denmark: '丹麦',
      czech: '捷克',
      croatia: '克罗地亚',
      bulgaria: '保加利亚',
      bosnia: '波黑',
      belgium: '比利时',
      belarus: '白俄罗斯',
      austria: '奥地利',
      albania: '阿尔巴尼亚',
      russia: '俄罗斯',

      // 中东
      yemen: '也门',
      united_arab_emirates: '阿联酋',
      turkey: '土耳其',
      tunisia: '突尼斯',
      syria: '叙利亚',
      saudi_arabia: '沙特阿拉伯',
      qatar: '卡塔尔',
      oman: '阿曼',
      morocco: '摩洛哥',
      libya: '利比亚',
      lebanon: '黎巴嫩',
      kuwait: '科威特',
      jordan: '约旦',
      israel: '以色列',
      palestine: '巴勒斯坦',
      iraq: '伊拉克',
      iran: '伊朗',
      egypt: '埃及',
      cyprus: '塞浦路斯',
      bahrain: '巴林',
      algeria: '阿尔及利亚'
    }
  },

  form: {
    required: '不得为空，请确认输入',
    userName: {
      required: '请输入用户账号',
      invalid: '用户账号格式不正确',
      placeHolder: '请输入用户账号/邮箱'
    },
    phone: {
      required: '请输入手机号',
      invalid: '手机号格式不正确',
      placeHolder: '请输入用户账号/邮箱'
    },
    pwd: {
      label: '密码',
      required: '请输入密码',
      invalid: '密码格式不正确，6-50位字符，必须包含字母、数字',
      placeHolder: '请输入密码'
    },
    confirmPwd: {
      label: '确认新密码',
      required: '请输入确认密码',
      invalid: '两次输入密码不一致',
      placeHolder: '请输入用户账号/邮箱'
    },
    code: {
      label: '验证码',
      required: '请输入验证码',
      invalid: '验证码格式不正确',
      placeHolder: '请输入验证码'
    },
    email: {
      label: '邮箱',
      required: '邮箱不得为空，请确认输入',
      invalid: '邮箱格式不正确',
      placeHolder: '邮箱格式'
    },
    account: {
      label: '账号',
      required: '请输入用户账号或邮箱',
      invalid: '账号格式不正确',
      placeHolder: '请输入用户账号或邮箱'
    },

    // 标准品
    categoryName: {
      required: '名称不得为空，请确认输入',
      invalid: '请输入2~50位有效字符，禁止输入<>',
      placeHolder: '2~50位的有效字符串',
      label: '名称'
    },
    classId: {
      required: '标准类目不得为空，请确认输入',
      placeHolder: '请选择标准类目',
      label: '标准类目'
    },
    categoryPic: {
      label: '品类图片',
      invalid: '请提供品类图标：尺寸为168x168像素，PNG格式，背景透明，文件大小不超过100KB。',
      placeHolder: '点击上传图片',
      required: '请上传品类图片'
    },
    categoryDesc: {
      label: '品类描述',
      placeHolder: '1~200位有效字符'
    },
    groupName: {
      label: '功能分组名称',
      placeHolder: '2~50位的有效字符串',
      required: '功能分组名称不得为空，请确认输入',
      invalid: '功能分组名称格式不正确'
    },
    functionName: {
      label: '功能名称',
      placeHolder: '2~50位的有效字符串',
      required: '功能名称不得为空，请确认输入',
      invalid: '请输入2~50位有效字符，禁止输入<>'
    },
    signCode: {
      label: '标识符',
      placeHolder: '2~50位的有效字符串，允许英文、数字、符号_ . 组合',
      required: '标识符不得为空，请确认输入',
      invalid: '请输入2~50位的有效字符串，允许英文、数字、符号_ . 组合'
    },
    description: {
      label: '描述',
      placeHolder: '1~200位有效字符',
      invalid: '请输入1~200位有效字符，禁止输入<>'
    },
    max: {
      label: '最大值',
      placeHolder: '1~15位的整数',
      required: '最大值不得为空，请确认输入',
      invalid: '请输入1~15位的整数'
    },
    min: {
      label: '最小值',
      placeHolder: '1~15位的整数',
      required: '最小值不得为空，请确认输入',
      invalid: '请输入1~15位的整数'
    },
    maxDouble: {
      label: '最大值',
      placeHolder: '输入小数，且最多保留三位小数',
      required: '最大值不得为空，请确认输入',
      invalid: '请输入小数，且最多保留三位小数'
    },
    minDouble: {
      label: '最小值',
      placeHolder: '输入小数，且最多保留三位小数',
      required: '最小值不得为空，请确认输入',
      invalid: '请输入小数，且最多保留三位小数'
    },
    stepDouble: {
      label: '步长',
      placeHolder: '输入小数，且最多保留三位小数',
      required: '步长不得为空，请确认输入',
      invalid: '请输入小数，且最多保留三位小数'
    },
    step: {
      label: '步长',
      placeHolder: '1~15位的整数',
      required: '步长不得为空，请确认输入',
      invalid: '请输入1~15位的整数'
    },
    unit: {
      label: '单位',
      placeHolder: '请选择单位'
    },
    length: {
      label: '数据长度',
      placeHolder: '输入范围：1~2147483647',
      required: '数据长度不得为空，请确认输入',
      invalid: '请输入范围在1~2147483647之间的值'
    },

    enumKey: {
      label: '参数值',
      placeHolder: '1~10位数字或英文',
      required: '参数值不得为空，请确认输入',
      invalid: '请输入1~10位的有效字符串，允许英文、数字组合'
    },
    enumVal: {
      label: '参数描述',
      placeHolder: '1~50位的有效字符串',
      required: '参数描述不得为空，请确认输入',
      invalid: '请输入1~50位有效字符，禁止输入<>'
    },
    arraySize: {
      label: '元素个数',
      placeHolder: '输入范围：1~2147483647',
      required: '元素个数不得为空，请确认输入',
      invalid: '请输入范围在1~2147483647之间的值'
    },
    booleanDesc: {
      placeHolder: '1~50位的有效字符串',
      required: '布尔值不得为空，请确认输入',
      invalid: '请输入1~50位有效字符，禁止输入<>'
    },
    paramName: {
      label: '参数名称',
      placeHolder: '2~50位的有效字符串',
      required: '参数名称不得为空，请确认输入',
      invalid: '请输入2~50位有效字符，禁止输入<>'
    },
    version: {
      label: '当前版本',
      placeHolder: '暂无历史版本'
    },

    nodeType: {
      label: '节点类型',
      placeHolder: '请选择节点类型',
      required: '节点类型不得为空，请确认输入',
      invalid: '节点类型格式不正确'
    },
    productPic: {
      label: '产品图片',
      invalid: '请提供产品图标：尺寸为168x168像素，PNG格式，背景透明，文件大小不超过100KB。',
      placeHolder: '点击上传图片',
      required: '请上传产品图片'
    },
    productName: {
      label: '产品名称',
      placeHolder: '2~50位的有效字符串',
      required: '产品名称不得为空，请确认输入',
      invalid: '请输入2~50位有效字符，禁止输入<>'
    },

    firmwareType: {
      label: '固件类型',
      placeHolder: '请输入固件类型',
      required: '固件类型不得为空，请确认输入',
      invalid: '固件类型格式不正确'
    },
    protocolIds: {
      label: '通讯方式',
      placeHolder: '请选择通讯方式',
      required: '通讯方式不得为空，请确认输入',
      invalid: '通讯方式格式不正确'
    },
    productDesc: {
      label: '产品描述',
      placeHolder: '1~200位有效字符'
    },
    firmwareName: {
      label: '固件版本名称',
      placeHolder: '2~50位的有效字符串',
      required: '固件版本名称不得为空，请确认输入',
      invalid: '请输入2~50位有效字符，禁止输入<>'
    },
    firmwareVision: {
      label: '固件版本号',
      placeHolder: '请输入固件版本号',
      required: '固件版本号不得为空，请确认输入',
      invalid: '固件版本号格式不正确'
    },

    firmwareTimeout: {
      label: '固件升级超时时间',
      placeHolder: '输入范围：1~200',
      required: '固件升级超时时间不得为空，请确认输入',
      invalid: '固件升级超时时间格式不正确'
    },
    firmwareUpd: {
      label: '固件升级方式',
      placeHolder: '请选择固件升级方式',
      required: '固件升级方式不得为空，请确认输入'
    },
    firmwareRemark: {
      label: '版本说明（中文）',
      placeHolder: '1~200位有效字符',
      invalid: '版本说明格式不正确'
    },

    firmwareFile: {
      label: '固件文件上传',
      invalid:
        '请提供固件文件：格式为.bin、.img、.fw、.hex、.tar、.zip、.upg、.dmg、.fwu、.rpm、.tar、.gz、.tgz、.apk、.udata、.aab，文件大小不超过700MB。',
      placeHolder: '点击上传固件文件',
      required: '请上传固件文件'
    },
    deviceName: {
      label: 'mock设备名称',
      placeHolder: '2~50位的有效字符串',
      required: 'mock设备名称不得为空，请确认输入',
      invalid: '请输入2~50位有效字符，禁止输入<>'
    },
    productId: {
      label: '产品选择',
      placeHolder: '请输入产品ID，搜索查看产品信息',
      required: '产品ID不得为空，请确认输入',
      invalid: '产品ID格式不正确'
    },
    deviceId: {
      label: '设备ID',
      placeHolder: '请输入设备ID',
      required: '设备ID不得为空，请确认输入',
      invalid: '设备ID格式不正确'
    },
    codeTip: {
      label: '二维码内容',
      placeHolder: '请输入二维码内容',
      required: '二维码内容不得为空，请确认输入'
    },
    langTxt: {
      label: '文案',
      required: '请输入对应语言的词条文案',
      invalid: '语言格式不正确'
    },
    scopeDevice: {
      required: '设备ID/MAC不得为空，请确认输入',
      invalid: '设备ID/MAC格式不正确',
      placeHolder: '请输入设备ID/MAC'
    },
  },
  // 账号管理
  accountp: {
    user: {
      label: '用户昵称',
      placeHolder: '2~50位的有效字符串',
      required: '用户昵称不得为空，请确认输入',
      invalid: '请输入2~50位有效字符，禁止输入<>'
    },
    account: {
      label: '用户账号',
      placeHolder: '5~50位的有效字符串，允许英文、数字、符号-组合',
      required: '用户账号不得为空，请确认输入',
      invalid: '请输入5~50位的有效字符串，允许英文、数字、符号-组合'
    },
    date: {
      label: '账号有效期',
      placeHolder: '请选择账号有效期',
      required: '账号有效期不得为空，请确认输入',
      invalid: '账号有效期不得为空，请确认输入'
    }
  },
  // 客户管理
  client: {
    editBaseMsg: '编辑基本信息',
    editAdmin: '修改管理员',
    pictureError: '请上传logo',
    name: {
      label: '全称',
      required: '全称不得为空，请确认输入',
      invalid: '请输入2~50位有效字符，禁止输入<>',
      placeholder: '2~50位的有效字符串'
    },
    address: {
      label: '详情地址',
      required: '详情地址不得为空，请确认输入',
      invalid: '详情地址格式不正确',
      placeholder: '2~200位的有效字符串'
    },
    domainName: {
      label: '域名',
      required: '域名不得为空，请确认输入',
      invalid: '请输入格式正确域名，允许英文、数字、符号 . - 组合',
      placeholder: '域名格式'
    },
    abbrName: {
      label: '简称',
      required: '简称不得为空，请确认输入',
      invalid: '请输入2~50位有效字符，禁止输入<>',
      placeholder: '2~50位的有效字符串'
    },
    dataCenter: {
      label: '数据中心分区',
      required: '数据中心分区不得为空，请确认输入',
      invalid: '数据中心分区格式不正确',
      placeholder: '请选择数据中心分区'
    },
    recordNumber: {
      label: '备案号',
      required: '备案号不得为空，请确认输入',
      invalid: '备案号格式不正确',
      placeholder: '2~50位的有效字符串'
    },
    country: {
      label: '地区',
      required: '地区不得为空，请确认输入',
      invalid: '地区格式不正确',
      placeholder: '2~200位的有效字符串'
    },
    city: {
      label: '所属城市',
      required: '所属城市不得为空，请确认输入',
      invalid: '所属城市格式不正确',
      placeholder: '2~200位的有效字符串'
    },
    creditCode: {
      label: '统一社会信用代码',
      required: '统一社会信用代码不得为空，请确认输入',
      invalid: '统一社会信用代码格式不正确',
      placeholder: '2~200位的有效字符串'
    },
    systemName: {
      label: '系统名称',
      required: '系统名称不得为空，请确认输入',
      invalid: '系统名称格式不正确',
      placeholder: '2~200位的有效字符串'
    },
    adminName: {
      label: '管理员名称',
      required: '管理员名称不得为空，请确认输入',
      invalid: '管理员名称格式不正确',
      placeholder: '2~50位的有效字符串'
    },
    username: {
      label: '用户账号',
      required: '用户账号不得为空，请确认输入',
      invalid: '用户账号格式不正确',
      placeholder: '5~50位的有效字符串，允许英文、数字、符号-组合'
    },
    email: {
      label: '邮箱',
      required: '邮箱不得为空，请确认输入',
      invalid: '邮箱格式不正确',
      placeholder: '邮箱格式'
    },
    logo: {
      label: 'logo',
      invalid: '请提供客户图标：尺寸为180x48像素，PNG格式，文件大小不超过3M。',
      placeHolder: '点击上传图片',
      required: '请上传logo图片'
    }
  },
  dialog: {
    verify: '身份验证',
    changeAdmin: '修改管理员'
  },
  backendErrorCode: {
    password: '密码错误，请输入正确的密码',
    500: '抱歉，服务器出现了问题，请稍后重试或联系技术支持团队。',
    403: '抱歉，您没有权限访问该内容或执行此操作。请联系管理员获取相应权限。',
    401: '登录已过期，请重新登录以继续操作。',
    503: '抱歉，服务器暂时无法处理您的请求，请稍后重试。',
    miss: '未捕捉的错误提示，注意处理!',
    2011: '授权签名已过期或失效，请校准当前系统时间或联系技术支持团队。',
    codeFast: '验证码获取太频繁，请稍后再试',
    accountNotFound: '当前账号不存在，请确认输入',
    checkCodeError: '验证码错误或过期，请确认验证码是否正确或重新获取',
    groupSame: '功能分组名称重复，请重新输入',
    categorySame: '标准品类名称重复，请重新输入',
    codeSame: '功能标识符名称重复，请重新输入',
    funcNameSame: '功能名称重复，请重新输入',
    usedMail: '该邮箱被使用',
    roleNameSame: '角色名称重复，请重新输入',
    roleUsed: '已关联账号的角色，需全部解绑后再删除',
    res1: '域名已存在',
    res2: '名称已存在',
    res3: '系统名称已存在',
    res4: '当前操作的客户下存在用户，不可删除',
    res5: '应用程序已存在',
    res6: '简称已存在',
    res7: '系统名称已存在',
    res8: '用户账号已存在',
    res9: '产品已存在',
    res10: '默认租户操作被禁止',
    res11: '用户登录错误',
    res12: '用户没有权限',
    res13: '抱歉，账号有效期超出时间范围，请重新分配权限',
    res14: '账户数量超过限制',
    res15: '用户账号非法',
    res16: '用户账号已存在',
    res17: '账户不可用',
    res18: '用户已被阻止',
    res19: '用户已被锁定',
    res20: '角色不存在',
    res21: '角色数量超过限制',
    res22: '菜单名称已存在',
    res23: '菜单权限已存在',
    res24: '菜单不存在',
    res25: '菜单权限为空',
    res26: '域名已存在',
    res27: '全称已存在',
    res28: '系统名称已存在',
    res29: '备案号已存在',
    res31: '统一社会信用代码已存在',
    1003009003: '该产品下有实际设备运行，不可删除',
    1003009001: '产品名称已经存在，请重新输入',
    1003009002: '产品功能组名称已经存在',
    1003009004: '产品已经发布',
    1003009005: '产品不存在',
    1003010001: '产品固件版本号已经存在',
    1003010002: '产品固件文件已经存在',
    1003010003: '产品固件正在使用',
    1003011001: '产品固件版本号已经存在',

    1009007001: 'ota任务不存在',
    1009007002: 'ota任务已执行，无法删除',
    1003007002: '设备存在未完成的OTA任务',
    1002000003: '设备不存在',
    1009005011: '客户不存在',
    1009001013: '账号不存在',
    1009005012: '客户被禁用',
    1009004006: '该标准品类不存在，请检查后重新操作',
    1009004007: '该标准品类已经发布，请检查后重新操作',
    1009009001: '该产品不存在，请检查后重新操作',
    1009009002: '该产品已被发布，请检查后重新操作',
    1001002006: '该邮箱已绑定其他账号，请检查后重新操作',
    1009010004: '固件类型不存在',
    1009010003: '删除的固件类型中存在已被使用的固件类型',
    1009009003: '该固件类型已有固件版本使用，不可取消勾选，请先处理相关固件版本',
    1003007004: '创建OTA任务的升级时间有误',

    '-1000000400': '当前产品已上架，暂不支持该操作',

  },
  layout: {
    help: '帮助文档'
  },
  icon: {
    fullscreen: '全屏',
    fullscreenExit: '退出全屏',
    collapse: '折叠菜单',
    expand: '展开菜单'
  },
  datatable: {
    itemCount: '共 {total} 条'
  },
  unit: {
    // 单位多语言待补充
    m: '米 / m',
    km: '千米 / km',
    dm: '分米 / dm',
    cm: '厘米 / cm',
    mm: '毫米 / mm',
    um: '微米 / μm',
    nm: '纳米 / nm',
    m2: '平方米 / ㎡',
    km2: '平方千米 / k㎡',
    mm2: '平方毫米 / m㎡',
    cm2: '平方厘米 / c㎡',
    hm2: '公顷 / h㎡',
    m3: '立方米 / m3',
    km3: '立方千米 / km3',
    cm3: '立方厘米 / cm3',
    mm3: '立方毫米 / mm3',
    l: '升 / L',
    ml: '毫升 / mL',
    n: '牛 / N',
    kg: '千克 / kg',
    g: '克 / g',
    mg: '毫克 / mg',
    pa: '帕斯卡 / Pa',
    kpa: '千帕 / kPa',
    hpa: '百帕 / hPa',
    mpa: '毫帕 / mPa',
    c: '摄氏度 / °C',
    t: '吨 / t',
    k: '开尔文 / K',
    f: '华氏度 / ℉',
    j: '焦耳 / J',
    kj: '千焦 / kJ',
    ev: '电子伏 / eV',
    wh: '瓦时 / Wh',
    kwh: '千瓦时 / kW·h',
    cal: '卡路里 / cal',
    w: '瓦特 / W',
    kw: '千瓦特 / kW',
    mw: '毫瓦 / mW',
    uw: '微瓦 / μW',
    hz: '赫兹 / Hz',
    rad: '弧度 / rad',
    point: '度 / °',
    min: '分 / ′',
    sed: '秒 / ″',
    ms: '米每秒 / m/s',
    kmh: '千米每小时 / km/h',
    kn: '节 / kn',
    year: '年 / year',
    month: '月 / month',
    week: '周 / week',
    day: '日 / day',
    h: '小时 / h',
    minu: '分钟 / min',
    sedcond: '秒 / s',
    msed: '毫秒 / ms',
    v: '伏特 / V',
    mv: '毫伏 / mV',
    a: '安培 / A',
    ka: '千安 / kA',
    ma: '毫安 / mA',
    ua: '微安 / μA',
    om: '欧姆 / Ω',
    fala: '法拉 / F',
    ufala: '微法 / μF',
    pfala: '皮法 / pF',
    nfala: '纳法 / nF',
    kgm3: '千克每立方米 / kg/m3',
    gm3: '克每立方米 / g/m3',
    mgm3: '毫克每立方米 / mg/m3',
    ugm3: '微克每立方米 / μg/m3',
    mgl: '毫克每升 / mg/L',
    gl: '克每升 / g/L',
    gml: '克每毫升 / g/mL',
    bit: '比特 / bit',
    lm: '流明 / lm',
    percent: '百分比 / %',
    db: '分贝 / dB',
    grav: '重力加速度 / grav',
    lux: '照度 / Lux',
    px: '像素 / pixel',
    ppm: '百万分率 / ppm',
    ugdm: '微克每平方分米每天 / μg/(d㎡·d)',
    b: '字节 / B',
    kb: '千字节 / KB',
    mb: '兆字节 / MB',
    gb: '吉字节 / GB',
    kcal: '千卡路里 / kcal',
    ugl: '微克每升 / μg/L',
    kvar: '千乏 / KVar',
    kvarh: '千乏时 / kvarh',
    m3h: '立方米每小时 / m3/h',
    mpal: '兆帕 / Mpa',
    ls: '升每秒 / L/s',
    kclh: '千卡每小时 / KCL/h',
    th: '吨每小时 / t/h',
    rmin: '转每分钟 / r/min',
    kgs: '公斤每秒 / kg/s',
    m3s: '立方米每秒 / m3/s',
    rh: '相对湿度 / %RH',
    uwcm2: '微瓦每平方厘米 / uw/cm2',
    kvars: '千乏 / kvar',
    kva: '千伏安 / KVA',
    kv: '千伏 / kV',
    nm3h: '标准立方米每小时 / Nm3/h',
    stepCount: '步 / stepCount',
    gear: '档 / gear',
    count: '次 / count',
    turn: '转每分钟 / turn/m',
    mms: '毫米每秒 / mm/s',
    mmol: '血糖 / mmol/L',
    mmHg: '血压 / mmHg',
    mlmin: '滴速 / ml/min',
    vm: '伏特每米 / V/m',
    nc: '牛顿每库仑 / N/C',
    uscm: '微西每厘米 / uS/cm',
    ppb: '微克每升 / ppb',
    ppt: '纳克每升 / ppt'
  },
  langList: {
    afrikaans: '南非语',
    ar: '阿拉伯语',
    az: '阿塞拜疆语',
    be: '比利时语',
    bg: '保加利亚语',
    ca: '加泰隆语',
    cs: '捷克语',
    cy: '威尔士语',
    da: '丹麦语',
    de: '德语',
    dv: '第维埃语',
    el: '希腊语',
    en: '英语',
    en_US: '英语(美国)',
    en_GB: '英语(英国)',
    eo: '世界语',
    es: '西班牙语',
    et: '爱沙尼亚语',
    eu: '巴士克语',
    fa: '法斯语',
    fi: '芬兰语',
    fo: '法罗语',
    fr: '法语',
    gl: '加里西亚语',
    gu: '古吉拉特语',
    he: '希伯来语',
    hi: '印地语',
    hr: '克罗地亚语',
    hu: '匈牙利语',
    hy: '亚美尼亚语',
    id: '印度尼西亚语',
    is: '冰岛语',
    it: '意大利语',
    ja: '日语',
    ka: '格鲁吉亚语',
    kk: '哈萨克语',
    kn: '卡纳拉语',
    ko: '朝鲜语',
    kok: '孔卡尼语',
    ky: '吉尔吉斯语',
    lt: '立陶宛语',
    lv: '拉脱维亚语',
    mi: '毛利语',
    mk: '马其顿语',
    mn: '蒙古语',
    mr: '马拉地语',
    ms: '马来语',
    mt: '马耳他语',
    nb: '挪威语(伯克梅尔)',
    nl: '荷兰语',
    ns: '北梭托语',
    pa: '旁遮普语',
    pl: '波兰语',
    pt: '葡萄牙语',
    pt_BR: '葡萄牙语(巴西)',
    qu: '克丘亚语',
    ro: '罗马尼亚语',
    ru: '俄语',
    sa: '梵文',
    se: '北萨摩斯语',
    sk: '斯洛伐克语',
    sl: '斯洛文尼亚语',
    sq: '阿尔巴尼亚语',
    sv: '瑞典语',
    sw: '斯瓦希里语',
    syr: '叙利亚语',
    ta: '泰米尔语',
    te: '泰卢固语',
    th: '泰语',
    tl: '塔加路语',
    tn: '茨瓦纳语',
    tr: '土耳其语',
    ts: '宗加语',
    tt: '鞑靼语',
    uk: '乌克兰语',
    ur: '乌都语',
    uz: '乌兹别克语',
    vi: '越南语',
    xh: '班图语',
    zh: '中文',
    zh_CN: '中文(简体)',
    zh_HK: '中文(香港)',
    zh_TW: '中文(繁体)',
    zu: '祖鲁语'
  },
  upload: {
    title: '下载或导入',
    uploadTip: '请上传文件',
    confirmUpload: '确定上传',
    result: '结果',
    download: '下载文件',
    downloadAll: '下载全部文件',
    downloadCurrent: '下载当前文件',
    menuFileName: '菜单翻译文件',
    allFileName: '标准品全部翻译文件',
    productAllFileName: '产品全部翻译文件',

    productName: '产品名称翻译文件',
    productGroup: '产品功能分组翻译文件',
    productFunction: '产品功能点翻译文件',
    categoryName: '标准品名称翻译文件',
    categoryGroup: '标准品功能分组翻译文件',
    categoryFunction: '标准品功能点翻译文件',

    tip1: '为保证导入数据的准确性，需下载模板进行编辑',
    tip2: '注意：导入后翻译不支持删除，仅支持覆盖',
    tip3: '请提供格式为.xlsx、.xls的文件，大小不能超过10M',
    tip4: '请核对并修改以下信息，再重新提交！',
    tip5: '您提交的内容有如下错误：',
    '001': '请检查文件格式，格式不正确',
    '002': '文件内容不能为空，请添加内容后重试',
    '003': '文件大小超出限制，请确保文件小于10MB',
    '004': '词条内容过长，请检查后重新导入（英文128字符，中文50字符）',
    '005': '请使用支持的语言格式',
    '006': '请使用支持的语言格式'
  },
  mutilLang: {
    funcGroup: '功能分组',
    func: '功能点',
    funcName: '功能名称',
    no: '序号',
    code: '词条code',
    langManger: '语种管理',
    currCode: '当前词条',
    pleaseInput: '请输入对应语言的词条文案',
    all: '所有：',
    selectedLang: '已选语种：',
    set: '进行配置',
    tip1: '如需要增加或者减少语种，可前往',
    tip2: '进行配置',
    tip3: '如需要增加或者减少语种，可以联系当前客户管理员进行配置。',
    tip4: '选中的语种将作用于所有产品和APP，请配置相关文案。',
    tip5: '最多选择20个语种',
    tip6: '默认语种不可取消',
    category: {
      categoryName: '标品名称'
    },
    product: {
      productLang: '产品多语言',
      productName: '产品名称',
      tip: '设置App相关文案的多语言'
    }
  },

};

export default local;
